<div class="flex flex-col md:grid md:grid-cols-4 gap-4">
  <app-user-change-profile class="md:col-span-3"></app-user-change-profile>
  <app-user-change-password></app-user-change-password>
</div>
